export const editFunctionModal = {
  extend: '/add-function-modal',
  ModalHeader: {
    title: 'Edit {{ key }} function'
  },
  Flex: {
    'Flex.info': {
      'AppField.title': {},
      // The key is fixed once the function exists: the kit's disabled state
      // (the real attribute, the `field-disabled` pair, the not-allowed
      // cursor) — never an opacity dim (DESIGN_LANGUAGE §8.1), and no
      // `pointerEvents: 'none'`, which hid that cursor.
      'AppField.key': {
        AppInput: {
          disabled: true
        }
      }
    },
    'Group.code': {
      minWidth: '100%',
      Title: {
        text: '{{ editor.addFunction.code | polyglot }}'
      },
      CodePreviewWidget: {
        props: (el, s) => ({
          minWidth: '100%',
          widthRange: null,
          theme: 'field-static',
          round: 'X2',
          padding: 'X2 X2 X2 -',
          minHeight: 'G1',
          Monaco: {
            foldLevel: false,
            opacity: 1,
            fileTab: {
              code: el.call('stringifyCode', s.value),
              type: 'javascript',
              filename: 'function.js',
              fileTabKey: 'function'
            },
            onCodeEditCallback: async (editor) => {
              const code = editor.getValue()
              const value = await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ code, {
                onError: (err) => {
                  s.update({
                    err
                  })
                }
              })

              if (!value) {
                return
              }

              s.quietReplace(
                {
                  code: el.call('encodeNewlines', code),
                  value
                },
                {
                  hoistUpdate: true
                }
              )
            }
          }
        })
      }
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      icon: 'checkmark',
      text: '{{ common.action.save | polyglot }}'
    },
    IconButton: {
      icon: 'trash outline',
      onClick: async (ev, el, s) => {
        el.call('removeItem', 'function', s.key)
        el.call('closeRouterModal')
      }
    }
  },
  // Flat v3.14 handlers. They sat in an `on: { init, submit }` wrapper, which
  // the v3.14 engine never reads (it fires `element.onInit` and binds
  // `element.onSubmit` only): the page never loaded its function, and the
  // add page's `onSubmit` (inherited through `extend`) ran on save instead.
  // Flat is safe here — the add page carries no `props.onInit` /
  // `props.onSubmit`, which would override an instance's flat handler at
  // merge time (edit-component-modal.js keeps its `props` for that reason).
  onInit: (el, s) => {
    const key = s.key || el.call('getLastLocationPath').slice(1)
    const item = el.getItem(key, s.type)
    return item && s.quietReplace(item)
  },
  onSubmit: async (e, el, s) => {
    e.preventDefault()
    el.call('updateItem', s.type, s.key, s)
    await el.call('closeRouterModal')
  }
}
